import React from 'react'
import { css } from '@emotion/core'

type Props = {
  icon: string
  title: string
  childrenWidth?: number
}

export const HeaderListContainer: React.FC<Props> = ({ icon, title, childrenWidth = 180, children }) => {
  return (
    <div className="parent-container" css={headerListContainerStyle(childrenWidth)}>
      <img src={icon} width={16} />
      <p>{title}</p>
      <img src={require('@/static/images/arrow_right.svg')} height={30} style={{ position: 'absolute', right: 8 }} />

      <div className="children-container">{children}</div>
    </div>
  )
}
const headerListContainerStyle = (childrenWidth: number) =>
  css({
    '.children-container': {
      position: 'absolute',
      width: childrenWidth,
      // 親メニューの幅 180px の右隣に出す。子の幅を変えても位置は親に合わせたまま
      left: 188,
      visibility: 'hidden',
      opacity: 0,
      transition: '0.3s',
      top: 0,
      boxShadow: '0px 3px 10px #0000003D',
      cursor: 'auto',
    },
    position: 'relative',
    ':hover': {
      '.children-container': {
        visibility: 'visible',
        opacity: 1,
        transition: '0s',
      },
    },
  })
